
























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import Hover from "./hover.vue";
@Component({
  components: {
    Hover
  }
})
export default class ProjectThirdControlBiaochi extends Vue {
  @Prop()
  private ziduan: any;
  @Prop()
  private index: any;
  private defaultValue: any = 50;
  private ifShowConfig: boolean = false;
  private temp: any = {};
  /**
   * @description 打开配置弹窗
   */
  private openConfigDialg() {
    this.temp = _.cloneDeep(this.ziduan);
    this.ifShowConfig = true;
  }
  /**
   * @description 保存
   */
  private save() {
    this.temp.content.setting.max.score = Number(
      this.temp.content.setting.max.score
    );
    this.temp.content.setting.min.score = Number(
      this.temp.content.setting.min.score
    );
    if (!this.temp.content.title) {
      this.$message.warning("题目名称不能为空");
      return;
    }
    if (
      this.temp.content.setting.max.score <= this.temp.content.setting.min.score
    ) {
      this.$message.warning("最大值不能小于等于最小值");
      return;
    }
    if (
      this.temp.content.setting.max.score === undefined ||
      this.temp.content.setting.min.score === undefined
    ) {
      this.$message.warning("最大值最小值都必须填写");
      return;
    }
    if (
      !this.temp.content.setting.max.name ||
      !this.temp.content.setting.min.name
    ) {
      this.$message.warning("最大值最小值刻度单位都必须填写");
      return;
    }
    this.defaultValue = Math.floor(
      (this.temp.content.setting.max.score -
        this.temp.content.setting.min.score) /
        2 +
        this.temp.content.setting.min.score
    );
    this.$emit("ziduanChange", this.temp);
    this.ifShowConfig = false;
  }
  /**
   * @description 取消/关闭弹窗
   */
  private closeDialog() {
    this.temp = {};
    this.ifShowConfig = false;
  }
  /**
   * @description 删除这个字段
   */
  private deleteThis() {
    this.$emit("del");
  }
}
